import React, { useState } from "react";
import ReactApexChart from '../../../../components/ReusableComponents/ApexChartLazy';
import "./common.css";
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import { Box } from "@mui/material";
import { offset } from "highcharts";

const CircleChart = ({ data = [93, 75, 69, 30, 20, 15] }) => {
  const { isMd } = useCustomLogic();
  const series = data;

  const options = {
    chart: {
      height: 350,
      type: "radialBar",
      offsetY: 20,
    },
    plotOptions: {
      radialBar: {
        offsetY: 0,
        startAngle: 0,
        endAngle: 270,
        hollow: {
          size: "30%",
        },
        dataLabels: {
          name: {
            show: false,
          },
          value: {
            show: false,
          },
        },
      },
    },
    colors: ["rgb(66, 212, 205)"],
    labels: [
      "RUNNING WATER",
      "FLUSH FACILITY",
      "LIQUID SOAP",
      "TISSUE PAPER",
      "MIRROR",
      "EXHAUST FAN",
    ],
    legend: {
      show: true,
      floating: true,
      fontSize: "12px",
      position: "left",
      offsetY: 0,
      offsetX: 0,
      labels: {
        useSeriesColors: true,
      },
      formatter: function (series, opts) {
        return series + ":  " + `${opts.w.globals.series[opts.seriesIndex]}%`;
      },
    },
    responsive: [
      {
        breakpoint: 320,
        options: {
          legend: {
            show: false,
          },
          chart: {
            height: 350,
          },
        },
      },
    ],
  };

  return (
    <Box id="chart" className="circleChart" style={{ display: "flex", justifyContent: "center" }}>
      <ReactApexChart options={options} series={series} type="radialBar" height={400} width={400} />
    </Box>
  );
};

export default CircleChart;
